/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'dva';
import { Table } from 'antd'
import GeneralSituation from './components/generalSituation';
import PieEcharts from './components/pieEcharts';
// import TableList from './components/tableList';
import ListSearch from './components/listSearch'


@connect(({ talentPool }) => ({
  ...talentPool,
}))


class TalentPool extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'talentPool/fetchTalentRoomOverview',
    });
    dispatch({
      type: 'talentPool/fetchTalentRoomCondition',
    }).then(data => {
      if (data && data[0]) {
        this.getCurrentCondition(data[0])
      }
    })
  }

  getCurrentCondition = data => {
    const { dispatch } = this.props;
    const { id } = data;
    dispatch({
      type: 'talentPool/save',
      payload: {
        currentCondition: data,
        tableLoading: true,
      }
    });
    dispatch({
      type: 'talentPool/fetchTalentRoomChart',
      params: {
        id
      }
    });
  }

  onSearch = data => {
    const { status } = data;
    const { conditionList } = this.props;
    const filterData = conditionList.filter(item => item.id == status)
    this.getCurrentCondition(filterData[0])
  }

  handleReset = () => {
    const { conditionList } = this.props;
    this.getCurrentCondition(conditionList[0])
  }

  render() {
    const { overviewList = [], conditionList = [], fieldPercentages = [], currentCondition, tableColumns = [], tableDataSource = [], tableLoading } = this.props;
    return (
      <>
        <div className='publicity'>
          <GeneralSituation data={overviewList} title='督学人员数据统计概况' />
          {
            !!fieldPercentages.length && <PieEcharts title={`${currentCondition.name}占比统计`} data={fieldPercentages} />
          }
        </div>
        <ListSearch statusList={conditionList} onSearch={this.onSearch} handleReset={this.handleReset} />
        <Table
          scroll={{ x: 'max-content' }}
          dataSource={tableDataSource}
          columns={tableColumns}
          loading={tableLoading}
        />;
      </>
    );
  }
}

export default TalentPool
